<template>
	<div ref="pie">

	</div>
</template>

<script>
	import echarts from 'echarts'
	import geoJson from './211000.json'
	var name = 'ly';
	echarts.registerMap(name, geoJson); //注册 地图
	function setOption(data) {
		var option = {
			title: {
				// text: "xx省 xx市 地图",
				left: 'center',
				textStyle: {
					color: '#000'
				}
			},
			
			geo: {
			  left:"12%",
			  right:'12%',
			  top:'5%',
			  bottom:'5%',
	          map: name,
	          label: {
	            normal: {
	              show: false,
	              formatter:params =>{
	              	console.error('dasdas',params)
	              },
	              rich:{
	              	 title: {
                        color: 'red',
                        align: 'center'
                    },
	              }
	            },
	            emphasis:{
	            	show:false
	            }
	          },
	          itemStyle: {
					normal: {
						borderColor: '#19A0DA',
						borderWidth: 2,
						areaColor: '#8FC3D1',
					},
					emphasis: {
						borderColor: '#19A0DA',
						borderWidth: 2,
						areaColor: '#8FC4D9',
					}
				},
	        },
			series: [
			{
				type: 'scatter',
				coordinateSystem: 'geo',
				data: [{
						name: "辽阳县",
						value: [
							122.899922148438,
							41.2616506171875,
							0
						]
					},
					{
						name: "白塔区",
						value: [
							123.199922148438,
							41.2916506171875,
							0
						]
					},
					{
						name: "太子河区",
						value: [
							123.159922148438,
							41.2516506171875,
							0
						]
					},
					{
						name: "文圣区",
						value: [
							123.319922148438,
							41.2716506171875,
							0
						]
					},
					{
						name: "宏伟区",
						value: [
							123.279922148438,
							41.1916506171875,
							0
						]
					},
					{
						name: "弓长岭区",
						value: [
							123.459922148438,
							41.1316506171875,
							0
						]
					},
					{
						name: "灯塔市",
						value: [
							123.339922148438,
							41.4116506171875,
							0
						]
					},
					{
						name: "辽阳县",
						value: [
							123.399922148438,
							40.9516506171875,
							0
						]
					},
				],
				symbolSize: .1,
				symbol: 'pin',
				label: {
					normal: {
						formatter: '{b}',
						position: 'left',
						show: true,
						fontSize: 12
					},
					emphasis: {
						show: false
					}
				},
				itemStyle: {
					normal: {
						color: '#000'
					}
				}

			}
			]
		}
		return option
	}
	export default {
		name: 'CsMap',
		props: ['args'],
		methods: {
			initChart() {
				window.addEventListener('resize', function() {
					this.myChart.resize()
				}.bind(this))
			},
			resize: function() {
				this.myChart.resize()
			},
		},
		mounted: function(el) {
			var container = this.$el;
			this.initChart();
			this.myChart = echarts.init(container);
			this.myChart.setOption(setOption(this.args), false);
		},
		watch: {
			updateFlag: function(val) {
				setTimeout(() => {
					this.myChart.resize()
				}, 150);
			}
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/echarts/mapChart.vue